<template>
    <div class="report-detail-export">
        <!--工具条-->
		<el-row :gutter="24" class="rde-tool-bar">
            <el-col :span="10">
                <el-input type="text" 
                    class="rde-input-info"
                    v-model="search_title" 
                    auto-complete="off" 
                    placeholder="輸入主題進行過濾"
                    :disabled="csvLoading">
                </el-input>
            </el-col>    
            <el-col :span="14" :gutter="24" style="display: flex; align-items: center;">
                <!-- <input type="file"
                    accept=".xls,.xlsx"
                    class="upload_file"
                    @change="readExcel($event)"
                /> -->
                <!-- <el-upload
                    ref="upload"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :before-upload="upload"
                    :show-file-list="false"
                    accept=".xlsx,.xls"
                    style="width: 100px; display: inline-flex;">
                    <el-button size="mini" type="text">
                        導入
                    </el-button>
                </el-upload> -->
                

                <!-- <el-button class="rde-btn" :loading="csvLoading" @click="readExcel">
				    下載報表
			    </el-button> 
                <downloadCsv ref="downloadCsv" :data = "csvData" name = "data.csv" :labels="labels" style="display: none;"></downloadCsv> -->
            </el-col>
		</el-row>
        <el-row :gutter="24" class="rde-tool-bar">
            <el-col :span="24">
                <input type="file"
                    ref="file"
                    accept=".xls,.xlsx"
                    @change="readExcel($event)" :disabled="csvLoading"/> 
                    <!-- style="position:absolute; clip:rect(0 0 0 0);" -->
                    <!-- <el-button class="rde-btn" @click="$refs.file.click()">選擇檔案</el-button> -->
                
                <!-- <el-upload
                    class="upload-demo"
                    ref="upload"     
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :auto-upload="false" 
                    :limit="1"     
                    :on-change="onChangeFile"
                    :on-remove="onRemoveFile">
                    <el-button size="small" type="primary">选择文件</el-button>
		        </el-upload> -->
            </el-col>
        </el-row>
        <el-row :gutter="24" class="rde-tool-bar">
            <el-col :span="24">
                <el-button class="rde-btn" :loading="csvLoading" @click="getStatisticsViewsWatchData">
				    下載報表
			    </el-button> 
                <downloadCsv ref="downloadCsv" :data = "csvData" name = "閱覽記錄.csv" :labels="labels" style="display: none;"></downloadCsv>

            </el-col>
            
        </el-row>
    </div>
</template>

<script>
import API from '../../api/api';
import * as XLSX from 'xlsx/xlsx.mjs'
export default {
    name: 'ReportDetailExport',
    data() {
        return {
            loading: false,
            search_title: '',
            search_names: [],
            upload_file: '',
            csvLoading: false,
            csvData:[],
            labels: {
                name: "工號",
                date: "日期",
                title: "主題",
                file: "名稱",
                duration: "觀看秒數",
                // ever_exported: "曾經匯出過", 
            },
        }
    },
    watch: {
        '$store.state.userInfoReady': {
            immediate: true,
            handler(val) {
                if (val) {
                    this.init();
                }
            }
        },
        '$store.state.report.dateRange': {
            immediate: false,
            handler(val) {
                //reload
                if (val && this.$store.state.report.dateRange.length > 1) {
                    if (this.$store.state.report.dateRange[0] instanceof Date) {
                        this.$store.state.report.dateRange[0] = this.$store.state.report.dateRange[0].getTime();
                    }
                    if (this.$store.state.report.dateRange[1] instanceof Date) {
                        this.$store.state.report.dateRange[1] = this.$store.state.report.dateRange[1].getTime();
                    }
                    // update method
                }
            }
        },
    },
    methods: {
        init() {

        },
        // upload(file,fileList){
        //     console.log("file",file);
        //     console.log("fileList",fileList);
        //     let files = {0: file}
        //     this.readExcel1(files);
        // },
        // onChangeFile(file, arr){ 
        //     //限制文件大小 
        //     let isLt2M = file.raw.size / 1024 / 1024 < 2;
        //     if(!isLt2M){ 

        //         this.$refs.uploadFile.clearFiles();
        //         return this.$message.error('上传文件大小不能超过 2MB!');
        //     }			
        //     this.userFile = file.raw;		
        // },
        // //文件移除
        // onRemoveFile(){ 
        //     this.userFile=null;
        // },
        // readExcel1(files) {
        //     var that = this;
        //     console.log(files);
        //     // 此处判断不严谨，思路只是根据传入的参数校验数据的完整性，可根据自己需求修改
        //     // 如果没有文件名
        //     if(files.length <= 0){
        //         return;
        //     }
        //     if(!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())){
        //         this.$Message.error('上传格式不正确，请上传xls或者xlsx格式');
        //         return;
        //     }

        //     const fileReader = new FileReader();
        //     fileReader.onload = (ev) => {
        //         try {
        //             const data = ev.target.result;
        //             const workbook = read(data, {
        //                 type: 'binary'
        //             });
        //             // 取第一张表
        //             const wsname = workbook.SheetNames[0];
        //             // 生成json表格内容
        //             const ws = utils.sheet_to_json(workbook.Sheets[wsname]);
        //             console.log(ws);
        //             // 后续为自己对ws数据的处理
        //         } catch (e) {
        //             return false;
        //         }
        //     };
        //     fileReader.readAsBinaryString(files[0]);
        // },
        readExcel(e) {
            // 讀取表格文件
            let that = this;
            const files = e.target.files;
            if (files.length <= 0) {
                return false;
            } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
                this.$message({
                message: "上傳格式不正確，請上傳xls或者xlsx格式",
                type: "warning"
                });
                return false;
            } else {
                // 更新获取文件名
                that.upload_file = files[0].name;
            }
            let ws;
            const fileReader = new FileReader();
            fileReader.onload = ev => {
                try {
                    const data = ev.target.result;
                    // console.log('data:'+JSON.stringify(data));
                    const workbook = XLSX.read(data, {
                        type: "binary"
                    });

                    const wsname = workbook.SheetNames[0]; //取第一張表
                    ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
                    that.search_names = ws.map(item => item['工號']);
                } catch (e) {
                    return false;
                }
            };
            fileReader.readAsBinaryString(files[0]);            
        },
        getStatisticsViewsWatchData() {
            this.csvLoading = true;
            this.csvData.splice(0);
            let startTime = null;
            let endTime = null;
            if (this.$store.state.report.dateRange.length > 1) {
                startTime = this.$store.state.report.dateRange[0];
                endTime = this.$store.state.report.dateRange[1];
            }

            API.getStatisticsWatchAdvanced({
                startTime: startTime,
                endTime: endTime,
                names: this.search_names,
                resource_title: this.search_title,
			}).then((response) => {
                if(response.status) {
                    redirectLogin(response.data);
                } else {
                    if (response.result.length == 0) {
                        this.$emit('searchHint', '查無資料!');
                    } else {
                        for (let i = 0; i < response.result.length; i++) {
                            let d = new Date(response.result[i].date);
                            let dString = d.getFullYear() + '/' + (d.getMonth()+1) + '/' + d.getDate();
                            let item = {
                                name: response.result[i].name,
                                date: dString,
                                title: response.result[i].resource_title,
                                file: response.result[i].file_name,
                                duration: response.result[i].file_watch_time,
                            };
                            this.csvData.push(item);
                        }
                        this.$refs.downloadCsv.generate();
                    }
                }
                this.csvLoading = false;
            });
        },
    },
}
</script>

<style lang="scss">
.report-detail-export {

    .rde-tool-bar {
        background: #FFFFFF;
        height: 48px;
        display: flex;
        align-items: center;

        .rde-btn {
            display: block;
            // float: right;
			background: #2E90F4;
			border-radius: 2px;
			color: #fff;
			font-size: 14px;
			height: 36px;
			border: none;
            white-space: nowrap;
		}

		.rde-btn:hover {
    		background: #42A0FF;
		}
        .rde-input-info {
            display: block;
            float: right;
		}
        .upload_file {
            display: block;
            float: right;
            // background: #2E90F4;
            // border-radius: 2px;
            // border: 1px;
            // margin-right: 10px;
        }
    }

    .overview-table {
        line-height: 48px;

        .overview-title {
            background-color: #F7F7F7;
            font-weight: 500;
            border:  1px solid #EEE ;
        }

        .overview-data {
            background: white;
            border:  1px solid #EEE ;
            border-top: 0px;
        }

        .overview-col1 {
            padding-left: 10px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// ReportDetailExport.vue?17560cd2